import { Drawer, Radio, Button, Tabs, Input, message, Table, Space, Rate, Modal, Pagination } from 'antd';
import { saveProblemFeedBack, pageProblemFeedBack, updateProblemFeedBackReviewed, getProblemFeedBack } from './api.js';
import React, { useState, useEffect, useRef } from 'react';
import DetailRecord from './subPage/detailRecord';
import { EditOutlined } from '@ant-design/icons';
import Upload from '../../compoment/upload.js';
import './Feedback.less';
import { getListDataDic } from '../../utils/dataProcessing';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
const Feedback = (props) => {
	// 初始化查詢
	useEffect(() => {}, []);
	const [open, setOpen] = useState(false);
	const [modalVisible, setFeedBackVisible] = useState(false);
	const [feedbackList, setFeedbackList] = useState([]);
	const [dataSource, setDataSource] = useState([]);
	const [pageSize, setPageSize] = useState(10);
	const [pageNum, setPageNum] = useState(1);
	const [total, setTotal] = useState(0);
	const [bizId, setBizId] = useState(undefined);
	const [newDetailData, setNewDetailData] = useState([]);
	const [detailoOen, setDetailOpen] = useState(false);
	const [subForm, setSubForm] = useState({
		statusCode: ''
	});
	const [form, setForm] = useState({
		bizSystemCode: '',
		bizSystemName: '',
		feedBackContent: '',
		feedBackTypeCode: '',
		feedBackTypeName: '',
		id: '',
		saveProblemFeedBackAttachmentDTOS: []
	});

	//展示显示反馈文本标识
	const [feedbackVisible, setIsHovered] = useState(false);
	const [commentForm, setcommentForm] = useState({
		id: '',
		judgeContent: '',
		judgeLevelCode: '',
		judgeLevelName: 0,
		isSolve: 1,
		saveProblemFeedBackAttachmentDTOS: []
	});
	const { sysMenus } = props;
	// 我的反馈表格配置
	const columns = [
		{
			title: '序号',
			render: (texe, record, index) => <Space>{index + 1}</Space>,
			width: 60
		},
		{
			title: '反馈类型',
			dataIndex: 'feedBackTypeName',
			key: 'feedBackTypeName',
			width: 98,
			ellipsis: true
		},
		{
			title: '反馈内容',
			dataIndex: 'feedBackContent',
			key: 'feedBackContent',
			width: 150,
			ellipsis: true
		},
		{
			title: '提交时间',
			dataIndex: 'feedBackTime',
			key: 'feedBackTime',
			width: 150,
			ellipsis: true
		},
		{
			title: '处理状态',
			dataIndex: 'statusName',
			key: 'statusName',
			width: 92,
			ellipsis: true
		},
		{
			title: '满意度',
			dataIndex: 'judgeLevelName',
			key: 'judgeLevelName',
			width: 170,
			render: (_, record) => (
				<Space size="middle">
					<Rate value={record.judgeLevelName} disabled />
				</Space>
			)
		},
		{
			title: '操作',
			key: 'action',
			align: 'center',
			fixed: 'right',
			width: 130,
			render: (_, record) => (
				<div className="tabBtn">
					<Button
						type="link"
						onClick={() => {
							seeDeatilDrawer(record);
						}}>
						{' '}
						详情{' '}
					</Button>
					{record.isHandle === 1 && record.statusCode !== '1481015' ? (
						<Button
							type="link"
							onClick={(e) => {
								console.log(e);
								setcommentForm({ ...commentForm, id: record.id });
								setFeedBackVisible(true);
								// setStatusCode(record.statusCode);
								// setIsHandle(record.isHandle);
							}}>
							解决
						</Button>
					) : null}
				</div>
			)
		}
	];
	const { TextArea } = Input;
	// 触发反馈管理抽屉
	const showDrawer = () => {
		console.log('触发弹框');
		setOpen(true);
		getList();
		getFeedbackType();
	};
	const onClose = () => {
		setOpen(false);
	};
	// // 设置组件绑定位置
	// const getDrawerDom = () => {
	// 	return document.getElementById('feedback');
	// };
	// 获取反馈类型
	const getFeedbackType = async () => {
		const response = await getListDataDic('1479');
		setFeedbackList(response);
	};

	// 注册成ref
	const uploadRecords = useRef();

	const drawerTitle = '意见反馈';
	// 获取数据
	function getList(newPageNum, newPageSize) {
		let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
		console.log('分页', pageNum, pageSize);
		pageProblemFeedBack({
			condition: {
				creatorId: userInfo?.userId || '',
				feedBackEndTime: '',
				feedBackStartTime: '',
				feedBackTypeCode: '',
				modifyEndTime: '',
				modifyStartTime: '',
				statusCode: ''
			},
			pageNum: newPageNum || pageNum,
			pageSize: newPageSize || pageSize
		}).then((res) => {
			if (res.success) {
				setDataSource(res.data.records);

				setTotal(res.data.total);
			}
		});
	}
	// 评分确认
	function modalOk() {
		if (commentForm.isSolve === 1 && !commentForm.judgeLevelName) {
			message.error('请选择评分');
			return;
		}
		let urlData = (uploadRecords.current.data || []).map((item) => {
			return {
				attachmentName: item.data.orginalFileName,
				attachmentUrl: item.data.uploadFileUrl,
				fileSize: item.data.fileSize,
				id: item.data.id,
				uploadDate: item.data.uploadTime
			};
		});

		setcommentForm({ ...commentForm, saveProblemFeedBackAttachmentDTOS: urlData });
		let submitCommentForm = { ...commentForm, saveProblemFeedBackAttachmentDTOS: urlData };
		updateProblem(submitCommentForm);
	}
	// 发表评价更改
	function updateProblem(commentForm) {
		updateProblemFeedBackReviewed(commentForm).then((res) => {
			console.log('回调数据', res);
			if (res.success) {
				setFeedBackVisible(false);
				message.success('处理成功');
				//清空内容
				setcommentForm({
					id: '',
					judgeContent: '',
					judgeLevelCode: '',
					judgeLevelName: 0,
					isSolve: 1,
					saveProblemFeedBackAttachmentDTOS: []
				});

				uploadRecords.current.wipeData();
				getList();
			} else {
				message.error(res.msg);
			}
		});
	}

	//评分取消
	function modalCancel() {
		setFeedBackVisible(false);
	}
	// 表格分页改变
	function paginationChange(pageNum, pageSize) {
		setPageSize(pageSize);
		setPageNum(pageNum);

		let newPageSize = pageSize;
		let newPageNum = pageNum;
		getList(newPageNum, newPageSize);
	}
	// 检查反馈是否进行填写数据
	function checkoutData() {
		if (!form.bizSystemCode) {
			message.error('请选择业务系统');
			return false;
		}
		if (!form.feedBackTypeCode) {
			message.error('请选择反馈类型');
			return false;
		}
		if (!form.feedBackContent) {
			message.error('请输入反馈内容');
			return false;
		}
		return true;
	}
	const sumitDataDebounce = debounce(() => {
		sumitData();
	}, 500);

	// 提交反馈
	function sumitData() {
		if (checkoutData()) {
			console.log('上传内容', uploadRecords.current.data);
			let urlData = (uploadRecords.current.data || []).map((item) => {
				return {
					attachmentName: item.data.orginalFileName,
					attachmentUrl: item.data.uploadFileUrl,
					fileSize: item.data.fileSize,
					id: item.data.id,
					uploadDate: item.data.uploadTime
				};
			});
			setForm({ ...form, saveProblemFeedBackAttachmentDTOS: urlData });

			let submitForm = { ...form, saveProblemFeedBackAttachmentDTOS: urlData };
			saveProblemFeedBack(submitForm).then((res) => {
				if (res.success) {
					message.success('已提交，感谢你的反馈');
					setForm({
						bizSystemCode: '',
						bizSystemName: '',
						feedBackContent: '',
						feedBackTypeCode: '',
						feedBackTypeName: '',
						id: '',
						saveProblemFeedBackAttachmentDTOS: []
					});
					uploadRecords.current.wipeData();
					setOpen(false);
				}
			});
		}
	}
	function seeDeatilDrawer(e) {
		setBizId(e.id);
		if (e.id) {
			// 获取详情回复信息    后端非得把  评论 和提问 ，分开不放回复记录里，所以只能自己拼， 下面是修复数据统一
			getProblemFeedBack({ id: e.id }).then((res) => {
				if (res.success) {
					// 修正 回复记录结构
					let data = res.data.problemFeedBackRecordVO;
					let problemReplyRecordVO = data.problemReplyRecordVO;
					setSubForm(res.data);
					(problemReplyRecordVO || []).forEach((item) => {
						item['typeText'] = '回复';
					});
					// 修正提问 结果
					let sessionRecordData = [
						{
							...data.problemFeedBackAskVO,
							typeText: data.problemFeedBackAskVO.feedBackTypeName,
							replyContent: data.problemFeedBackAskVO.feedBackContent
						}
					];

					sessionRecordData = sessionRecordData.concat(problemReplyRecordVO, {
						...data.problemFeedBackJudgeVO,

						typeText: '评价'
					});
					sessionRecordData = sessionRecordData.filter((i) => i);
					setNewDetailData(sessionRecordData);
					console.log('图片详情', sessionRecordData);
					setDetailOpen(true);
				}
			});
		}
	}
	function closeDeatilDrawer() {
		setDetailOpen(false);
	}
	// 控制隐藏悬浮提示文字
	const feedBackEnter = () => {
		setIsHovered(true);
	};
	const feedBackLeave = () => {
		setIsHovered(false);
	};

	return (
		<>
			<div id="feedback">
				<div className="feedbackText" onMouseEnter={feedBackEnter} onMouseLeave={feedBackLeave} onClick={showDrawer}>
					<EditOutlined className="hoverBell" />
					{feedbackVisible && <span className="feedbackText_yj">意见反馈</span>}
				</div>
				{/* 反馈抽屉操作 */}
				<Drawer placement="right" onClose={onClose} title={drawerTitle} visible={open} width="900" maskClosable={false}>
					<Tabs>
						<Tabs.TabPane tab="意见反馈" key="item-1">
							<div className="feedbackFormItem">
								<span className="formValue">
									<span className="redStar">*</span>反馈类型:
								</span>
								<Radio.Group value={form.feedBackTypeCode}>
									{feedbackList.map((item, index) => {
										return (
											<Radio
												value={item.value}
												onChange={(e) => {
													setForm({
														...form,
														feedBackTypeCode: e.target.value,
														feedBackTypeName: feedbackList[index].label
													});
												}}>
												{item.label}
											</Radio>
										);
									})}
								</Radio.Group>
							</div>
							<div className="feedbackFormItem">
								<span className="formValue">
									<span className="redStar">*</span>业务系统:
								</span>
								<Radio.Group value={form.bizSystemCode}>
									{sysMenus.map((item, index) => {
										return (
											<Radio
												onChange={(e) => {
													setForm({
														...form,
														bizSystemCode: e.target.value,
														bizSystemName: sysMenus[index].asName
													});
												}}
												value={item.id}>
												{item.asName}
											</Radio>
										);
									})}
								</Radio.Group>
							</div>
							<div className="feedbackFormItem">
								{' '}
								<span className="redStar">*</span>问题描述
							</div>
							<TextArea
								rows={4}
								placeholder="请输入问题反馈"
								maxLength={1000}
								showCount
								value={form.feedBackContent}
								onChange={(e) => {
									setForm({
										...form,
										feedBackContent: e.target.value
									});
								}}
							/>
							<div className="feedbackFormItem martop10">上传图片</div>
							{/* <div style={{ height: '70%', width: '80%', border: '1px solid #000' }}> */}
							<div>
								<Upload ref={uploadRecords}></Upload>
								{/* <EditorDemos
									controls={controls}
									contentStyle={{ height: 210, boxShadow: 'inset 0 1px 3px rgba(0,0,0,.1)' }}
									hospitalNote={hospitalNote}
									hospitalNoteChange={setHospitalNote}></EditorDemos> */}
							</div>
							<div className="bottomButton martop24">
								<Button type="primary" onClick={sumitDataDebounce}>
									提交
								</Button>
							</div>
						</Tabs.TabPane>

						<Tabs.TabPane tab="我的反馈" key="item-2">
							<Table
								dataSource={dataSource}
								columns={columns}
								pagination={false}
								rowKey={(record) => {
									return record.id + Date.now(); //在这里加上一个时间戳就可以了
								}}
							/>
							<div className="tablePagination">
								<Pagination defaultCurrent={1} total={total} onChange={paginationChange} showSizeChanger></Pagination>
							</div>
						</Tabs.TabPane>
					</Tabs>
				</Drawer>

				{/* 反馈详情 */}
				<Drawer title="反馈详情" placement="right" onClose={closeDeatilDrawer} visible={detailoOen} width="900">
					<DetailRecord
						newDetailData={newDetailData}
						bizId={bizId}
						setDetailOpen={setDetailOpen}
						subForm={subForm}></DetailRecord>
				</Drawer>
				{/* 评价弹框 */}
				<Modal
					title="解决"
					visible={modalVisible}
					onOk={modalOk}
					onCancel={modalCancel}
					debounce
					okText="确认"
					cancelText="取消">
					<div>
						<div className="feedbackFormItem">
							<span className="formLabel marRight8px">
								<span className="redStar">*</span> 问题解决
							</span>
							<Radio.Group
								onChange={(e) => {
									console.log(e);

									setcommentForm({
										...commentForm,

										judgeLevelCode: '',
										isSolve: e.target.value ? 1 : 0,
										judgeLevelName: null
									});
								}}
								value={commentForm.isSolve}>
								<Radio value={1}>已解决</Radio>
								<Radio value={0}>未解决</Radio>
							</Radio.Group>
						</div>
						{commentForm.isSolve === 1 ? (
							<div className="feedbackFormItem">
								<span className="formLabel marRight8px">
									<span className="redStar">*</span> 综合评分
								</span>
								<Rate
									value={commentForm.judgeLevelName}
									onChange={(e) => {
										console.log(e);
										setcommentForm({
											...commentForm,
											judgeLevelName: e,
											judgeLevelCode: `14820${e > 1 ? e * 5 : '05'}`
										});
									}}
								/>
							</div>
						) : null}
						<div className="feedbackFormItem">
							<div className="pinglun">评语</div>
							<TextArea
								rows={4}
								placeholder="请输入评语"
								maxLength={100}
								showCount
								value={commentForm.judgeContent}
								onChange={(e) => {
									console.log(e);
									setcommentForm({ ...commentForm, judgeContent: e.target.value });
								}}
							/>
						</div>
						<div className="feedbackFormItem">
							<div className="pinglun">上传图片</div>
							<div>
								<Upload ref={uploadRecords}></Upload>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		</>
	);
};
const mapStateToProps = (state) => {
	return {
		sysMenus: state.sysMenus
	};
};

export default connect(mapStateToProps)(Feedback);
